export default __webpack_public_path__ + "static/media/berserkinspiration.e57aa245.png";